import { render, staticRenderFns } from "./StaffCourseForm.vue?vue&type=template&id=3670d488&"
import script from "./StaffCourseForm.vue?vue&type=script&lang=js&"
export * from "./StaffCourseForm.vue?vue&type=script&lang=js&"
import style0 from "./StaffCourseForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "StaffCourseForm.vue"
export default component.exports